export default {
  getOffers: state => state.offers
}
